import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var breakSentence = /\b(\w|\w+[^\w\s]*\w+)\b/g;
var TextAreaMaxWords = /*#__PURE__*/function (_Component) {
  function TextAreaMaxWords(props) {
    var _this;
    _classCallCheck(this, TextAreaMaxWords);
    _this = _callSuper(this, TextAreaMaxWords, [props]);
    var text = props.text;
    _this.state = {
      text: text
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.exceededMaxWords = _this.exceededMaxWords.bind(_this);
    return _this;
  }
  _inherits(TextAreaMaxWords, _Component);
  return _createClass(TextAreaMaxWords, [{
    key: "handleChange",
    value: function handleChange(event) {
      var text = event.target.value;
      var exceededLimit = this.exceededMaxWords(text);
      if (!exceededLimit) {
        this.setState({
          text: text
        });
      }
    }
  }, {
    key: "exceededMaxWords",
    value: function exceededMaxWords(text) {
      var wordsCount = text.match(breakSentence) || [];
      var maxWords = this.props.maxWords;
      return wordsCount.length > maxWords;
    }
  }, {
    key: "render",
    value: function render() {
      var text = this.state.text;
      var _this$props = this.props,
        fieldName = _this$props.fieldName,
        fieldId = _this$props.fieldId,
        placeholder = _this$props.placeholder,
        required = _this$props.required,
        className = _this$props.className,
        label = _this$props.label,
        maxWords = _this$props.maxWords;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-group mt-4"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: fieldId
      }, label, ' ', "(maximum", maxWords, ' ', "words)"), /*#__PURE__*/React.createElement("textarea", {
        className: className,
        name: fieldName,
        id: fieldId,
        rows: "4",
        placeholder: placeholder,
        onChange: this.handleChange,
        value: text,
        required: required
      }));
    }
  }]);
}(Component);
TextAreaMaxWords.propTypes = {
  text: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  fieldId: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  maxWords: PropTypes.number.isRequired
};
TextAreaMaxWords.defaultProps = {
  text: '',
  placeholder: '',
  required: '',
  className: ''
};
export default TextAreaMaxWords;